import { get } from 'lodash'

export const handleResponseError = (e, defaultMessage) => {
  if (get(e, 'response.data.errors')) {
    const errors = e.response.data.errors;
    const errorMessages = Object.values(errors).flat();
    if (errorMessages.length > 0) {
      return errorMessages.join('\n');
    }
  }

  if (get(e, 'response.message')) {
    return e.response.message
  }
  else if (get(e, 'response.data.message')) {
    return e.response.data.message
  }
  return defaultMessage ? defaultMessage : e.message
}